module.exports = __webpack_public_path__ + "static/property2-93d3773e1480e8b94f46a256ed04db85.png";